// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemVariablesUI.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {

  var m = require('mobx');

  function SystemVariablesUI(data) {
    this.$sourceNode = null;

    var props = {
      visible: false,
      left: 0,
      top: 0,
      sourceType: null,
      cursorPosition: 0
    };

    m.extendObservable(this, props);
    data && this.populateData(data);
  };

  /**
   * populate data
   * @param  {object} data
   */
  SystemVariablesUI.prototype.populateData = m.action(function (data) {
    this.visible = data.visible;
    this.left = data.left;
    this.top = data.top;
    this.sourceType = data.sourceType;
    this.cursorPosition = data.cursorPosition;
    this.$sourceNode = data.$sourceNode;
  });

  /**
   * Update visible value
   * @param  {Boolean} value
   */
  SystemVariablesUI.prototype.updateVisible = function (value) {
    this.visible = value;
  };

  module.exports = SystemVariablesUI;

} ());



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.SystemVariablesUI.js